// CognitiveStateIndicator — promoted from learner-app/components/analytics
// to @flowgenix/shared-ui (Phase 2 / Step C-3.3).
//
// Renderer for the `cognitive_state_indicator` widget kind. Pure React;
// no DOM APIs, no i18n coupling, no heavy deps.
import React from 'react';
import './CognitiveStateIndicator.css';

const STATE_CONFIG = {
  optimal: { label: 'Optimal', color: '#34d399', icon: '\u2714' },
  challenged: { label: 'Challenged', color: '#fbbf24', icon: '\u26A0' },
  fatigued: { label: 'Fatigued', color: '#f87171', icon: '\u23F8' },
  disengaged: { label: 'Disengaged', color: '#94a3b8', icon: '\u2026' },
  flow: { label: 'In Flow', color: '#818cf8', icon: '\u26A1' },
};

export default function CognitiveStateIndicator({ state, confidence, trend, adaptation }) {
  const cfg = STATE_CONFIG[state] || STATE_CONFIG.optimal;

  return (
    <div className="cog-state-container" style={{ borderColor: cfg.color }}>
      <div className="cog-state-header">
        <span className="cog-state-icon" style={{ color: cfg.color }}>{cfg.icon}</span>
        <span className="cog-state-label" style={{ color: cfg.color }}>{cfg.label}</span>
        {confidence != null && (
          <span className="cog-state-confidence">{Math.round(confidence * 100)}%</span>
        )}
      </div>
      {trend && (
        <div className="cog-state-trend">
          Trend: <span className={`trend-${trend}`}>{trend}</span>
        </div>
      )}
      {adaptation && (
        <div className="cog-state-adaptation">
          <span className="adaptation-msg">{adaptation.message}</span>
        </div>
      )}
    </div>
  );
}

CognitiveStateIndicator.kind = 'cognitive_state_indicator';
CognitiveStateIndicator.displayName = 'CognitiveStateIndicator';
